import * as React from "react";
import { useAPI } from "../../hooks/api-hook";
import { AppContext } from "../../setup/context";
import { HomeBreadcrumbWrapper } from "./HomeBreadcrumbWrapper";

/**
 * Breadcrumb component for the Page Live route.
 * Fetches the page data and displays the actual page name.
 */
export const PageLiveBreadcrumb: React.FC<{ pageId: string }> = ({ pageId }) => {
    const context = React.useContext(AppContext);

    const loadPageRunner = useAPI(
        context.getPageAPI().load
    );

    React.useEffect(() => {
        loadPageRunner.submitRun(pageId);
    }, [pageId]);

    const pageName = loadPageRunner.status === "Succeeded"
        ? loadPageRunner.data.output.title
        : "Page";

    return <HomeBreadcrumbWrapper items={[
        { text: pageName, href: `#/page/${pageId}/live` }
    ]} />;
};
